module.exports = __webpack_public_path__ + "static/media/sf_2200_gray.4588065d8cc1addb06451df8b6945881.png";